<template>
  <div class="app-main-content accounting-closing">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane :label="$t('CargoMsg.Cargo_PEFEA')" name="adjustRate">
          <adjust-rate key="adjustRate" ref="adjustRate" :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_CloseAccount')" name="closingAccount">
          <closing-account
            key="closingAccount"
            ref="closingAccount"
            :account-set="accountSet"
            @closingFiscalPeriodClick="closingFiscalPeriodHandler"
            @openFiscalPeriodSuccess="updateCarryoverAccountingDocument"
          />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_CarryOverProfitLoss')" name="carryOver">
          <carry-over key="carryOver" ref="carryOver" :account-set="accountSet" />
        </el-tab-pane>
      </el-tabs>
      <span style="position: absolute; right: 10px; margin-top: 5px;">
        <el-link :type="lbAccountType" no="1" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
      </span>
    </div>
    <!-- 选择账套 -->
    <account-set-popup
      ref="refAccountSetPopup"
      :visible.sync="accountSetPopup.visible"
      :mode="accountSetPopup.mode"
      :load-fiscal-period-info-flag="true"
      :load-accounting-document-type-flag="false"
      :load-mapping-departments-flag="false"
      :load-mapping-staffs-flag="false"
      :load-accounting-documents-rule-flag="false"
      no="2"
      @select="data=>{accountSet=data;updateCarryoverAccountingDocument();}"
      @cancel="()=>accountSetPopup.visible=false"
    />
  </div>
</template>

<script>
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import AdjustRate from '@/views/cargo/v0/FinanceManage/AccountingClosing/AdjustRate'
import CarryOver from '@/views/cargo/v0/FinanceManage/AccountingClosing/CarryOver'
import ClosingAccount from '@/views/cargo/v0/FinanceManage/AccountingClosing/ClosingAccount'
import { getLoading } from '@/utils/utilBaseElement'
import { closingFiscalPeriod } from '@/api/financeManage/fiscalPeriod'
import moment from 'moment'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'AccountingClosing',
  components: { AccountSetPopup, AdjustRate, CarryOver, ClosingAccount },
  data() {
    return {
      activeTabName: 'adjustRate',
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' }
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      this.accountSetPopup.visible = true
    },
    // 结账
    closingFiscalPeriodHandler() {
      if (!this.$refs.carryOver) {
        this.$confirm(this.$t('CargoMsg.Cargo_SUTCPALVIBC'), this.$t('Message.Warning'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning'
        }).then(() => {
          this.activeTabName = 'carryOver'
        }).catch(() => {})
        return
      }
      if (!this.$refs.carryOver.validatePreCarryOver()) return
      // 新的会计期间
      const newFiscalPeriod = {}
      newFiscalPeriod.beginDate = moment(this.accountSet.currentFiscalPeriod.beginDate).add(1, 'months').format('YYYY-MM-DD')
      newFiscalPeriod.endDate = moment(newFiscalPeriod.beginDate).endOf('month').format('YYYY-MM-DD')
      newFiscalPeriod.month = moment(newFiscalPeriod.beginDate).format('M')
      newFiscalPeriod.year = moment(newFiscalPeriod.beginDate).format('YYYY')
      newFiscalPeriod.accountSetUuid = this.accountSet.uuid
      const requestBody = {
        'accountSetKey': this.accountSet.uuid,
        'currentFiscalPeriodKey': this.accountSet.currentFiscalPeriod.uuid,
        'entity': newFiscalPeriod,
        'prefix': this.$refs.carryOver.prefix,
        'documentNo': this.$refs.carryOver.documentNo,
        'summary': this.$refs.carryOver.summary,
        'documentDate': this.$refs.carryOver.documentDate,
        'carryOverAccountTitle': this.$refs.carryOver.carryOverAccountTitle,
        'carryOverUnProfitAccountTitle': this.$refs.carryOver.carryOverUnProfitAccountTitle,
        'carryOverBeforeAccountTitle': this.$refs.carryOver.carryOverBeforeAccountTitle,
        'branchId': this.$store.getters.currentOfficeId }
      if (this.$refs.closingAccount.isProcessing) return
      this.$refs.closingAccount.processing = true
      this.loading = getLoading()
      closingFiscalPeriod(requestBody).then(res => {
        if (res.data !== '') {
          this.$message.success(this.$t('CargoMsg.Cargo_CloseAccountSuccessfully'))
          this.$nextTick(() => {
            this.accountSet.currentFiscalPeriod = res.data.currentFiscalPeriod
            this.accountSet.result = res.data.result
            this.$refs.carryOver.updateCarryoverAccountingDocument()
          })
        } else {
          this.$confirm(this.$t('CargoMsg.Cargo_ACPCOIM'), this.$t('Message.Warning'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            showCancelButton: false,
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            type: 'warning'
          }).then(() => {}).catch(() => {})
        }
      }).finally(() => {
        this.$refs.closingAccount.processing = false
        this.loading.close()
      })
    },
    updateCarryoverAccountingDocument() {
      if (this.$refs.carryOver) {
        this.$nextTick(() => {
          this.$refs.carryOver.updateCarryoverAccountingDocument()
        })
      }
    }
  }
}
String.prototype.format = function() {
  if (arguments.length == 0) return this
  for (var s = this, i = 0; i < arguments.length; i++) {
    s = s.replace(new RegExp('\\{' + i + '\\}', 'g'), arguments[i])
  }
  return s
}
</script>

<style lang="scss">
.accounting-closing {
  .el-form-item-documentDate {
    width: 180px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 70px !important;
      text-align: center;
    }
    .el-date-editor {
      width: 110px;
    }
  }
  .el-form-item-prefix {
    width: 110px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 50px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 60px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-documentNo {
    width: 110px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 50px !important;
      text-align: center;
    }
    .el-input-number {
      width: 60px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-summary {
    width: 200px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 70px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 130px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-accountTitle {
    width: 200px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 50px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-carryOverAccountTitle {
    width: 235px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 85px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-carryOverBeforeAccountTitle {
    width: 290px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 140px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-carryOverUnProfitAccountTitle {
    width: 250px;
    margin-right: 2px !important;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 100px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
}
</style>
